import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importerer sprogfiler som TypeScript
import translationDA from './locales/da';
import translationEN from './locales/en';

// ressourcer
const resources = {
  da: {
    translation: translationDA
  },
  en: {
    translation: translationEN
  }
};

i18n
  // detekterer brugerens sprog fra browser
  .use(LanguageDetector)
  // passes i18n down to react-i18next
  .use(initReactI18next)
  // initaliserer i18next
  .init({
    resources,
    fallbackLng: 'da', // brug dansk som standard
    interpolation: {
      escapeValue: false // react håndterer allerede XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n; 